import { Component, OnInit } from '@angular/core';
import { Client } from 'src/app/shared/models/client';
import { AuthService } from 'src/app/shared/services/auth.service';

@Component({
  selector: 'app-user-dashboard',
  templateUrl: './user-dashboard.component.html',
  styleUrls: ['./user-dashboard.component.scss'],
})
export class UserDashboardComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
